import { useMemo } from 'react';
import { erstelleAbgleich } from './abgleich';
import type {
  AbgleichZeile,
  MitarbeiterabgleichQuelle,
  MitarbeiterabgleichZusammenfassung,
} from './entities/Mitarbeiterabgleich';
import { MOCK_MITARBEITERABGLEICH_QUELLE } from './mock/mitarbeiterabgleich.mock';
import { useAbgleichJobs } from './useAbgleichJobs';

function useMitarbeiterabgleichQuelle(): {
  quelle?: MitarbeiterabgleichQuelle;
  error?: string;
} {
  return { quelle: MOCK_MITARBEITERABGLEICH_QUELLE };
}

type MitarbeiterabgleichErgebnis = {
  zeilen: AbgleichZeile[];
  zusammenfassung?: MitarbeiterabgleichZusammenfassung;
  error?: string;
  starteAbgleich: () => void;
};

export function useMitarbeiterabgleich(): MitarbeiterabgleichErgebnis {
  const { quelle, error } = useMitarbeiterabgleichQuelle();
  const { letzterJob, letzterAbruf, starteAbgleich } = useAbgleichJobs();

  const abgleich = useMemo(
    () =>
      quelle &&
      erstelleAbgleich(quelle.e2nMitarbeiter, quelle.datevMitarbeiter),
    [quelle],
  );

  if (!abgleich) {
    return { zeilen: [], error, starteAbgleich };
  }

  return {
    zeilen: abgleich.zeilen,
    zusammenfassung: {
      gesamt: abgleich.gesamt,
      uebereinstimmend: abgleich.uebereinstimmend,
      letzterJob,
      letzterAbruf,
    },
    starteAbgleich,
  };
}
